import React from 'react';
import { AccidentList } from '@/components/AccidentList';
import { AccidentItemHSPProps } from '@/components/AccidentItemHSP';
import { CardSmallStats } from '@/components/CardSmallStats';

export interface RaportHSPHistoryData {
  accidents?: AccidentItemHSPProps[];
}

export interface RaportHSPHistoryProps {
  historyData: RaportHSPHistoryData;
}

export const RaportHSPHistory: React.FC<RaportHSPHistoryProps> = ({
  historyData,
}) => {
  const { accidents } = historyData;

  return (
    <div className="mt-10 space-y-8">
      {/* Statystyki historii */}
      {accidents && accidents.length > 0 && (
        <div className="mb-20 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
          <CardSmallStats
            icon="car-accident"
            title="Liczba odnotowanych szkód"
            subtitle={`ilość szkód: ${1}`}
            variant="warning"
          />

          <CardSmallStats
            icon="ruler-measure"
            title="Łączna wartość napraw"
            subtitle={`28.000 PLN`}
          />

          <CardSmallStats
            icon="car-crash"
            variant="danger"
            title="Szkody całkowite"
            subtitle={`ilość szkód: ${0}`}
          />

          <CardSmallStats
            icon="location-pin"
            title="Kraje występowania szkód"
            subtitle={`Niemcy, Polska`}
          />
        </div>
      )}
      {/* Historia szkód */}
      {accidents && (
        <AccidentList
          accidents={accidents}
          title="Historia szkód pojazdu"
          showCount={true}
          i18n={{
            title: 'Historia szkód pojazdu',
            noAccidentsTitle: 'Brak zarejestrowanych szkód',
            noAccidentsDescription:
              'Nie znaleziono żadnych zapisów o szkodach w historii tego pojazdu.',
            entryNumberPrefix: 'Wpis nr XX',
            damageReportedTitle: 'Odnotowano szkodę pojazdu XX',
            damageValueLabel: 'Wartość szkody',
            damageCountryLabel: 'Kraj szkody',
            eventDetailsTitle: 'Szczegóły zdarzenia XX:',
            damagedElementsLabel: 'Elementy które mogły ulec uszkodzeniu XX:',
            damageLocationLabel: 'Miejsce szkody XX :',
            mileageLabel: 'Przebieg przy wystąpieniu XX zdarzenia',
            kmUnit: 'km',
            photoGalleryTitle: 'Zdjecia szkód pojazdu XX',
            flagAltTemplate: 'Flaga {country} XX',
          }}
        />
      )}
    </div>
  );
};
